import { render, staticRenderFns } from "./SoftToken.vue?vue&type=template&id=1c93b63c&scoped=true&"
import script from "./SoftToken.vue?vue&type=script&lang=js&"
export * from "./SoftToken.vue?vue&type=script&lang=js&"
import style0 from "./SoftToken.vue?vue&type=style&index=0&id=1c93b63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93b63c",
  null
  
)

export default component.exports